// src/services/authorService.js
import api from './api';

export function fetchAuthors() {
  return api.get('/authors');
  //return api.get('/authors/search-elastic');
}

export function getAuthorById(id) {
  return api.get(`/authors/${id}`);
}

/**
 * Criação de autor
 * allowDuplicateName: bool -> se true, backend ignora o aviso de duplicidade
 * useElastic: bool       -> mantém seu parâmetro já existente
 */
export function createAuthor(data, allowDuplicateName = false, useElastic = false) {
  return api.post("/authors", data, {
    params: {
      useElastic,
      allowDuplicateName,
    },
  });
}

/**
 * Edição de autor
 * allowDuplicateName segue a mesma lógica do create
 */
export function updateAuthor(data, allowDuplicateName = false, useElastic = false) {
  return api.put(`/authors/${data.authorId}`, data, {
    params: {
      useElastic,
      allowDuplicateName,
    },
  });
}


export function deleteAuthor(id, useElastic = false) {
  return api.delete(`/authors/${id}`, {
    params: { useElastic }
  });
}

export function deleteAuthorsBatch(ids, useElastic = false) {
  return api.delete('/authors', {
    params: { useElastic },  // vai na query string
    data: ids                // vai no corpo da requisição
  });
}


export async function fetchAuthorsPaged(pageNumber, pageSize, search = '') {

  //alert ('pageNumber:' + pageNumber + '\npageSize: ' + pageSize + '\nsearch: ' + search )
  return api.get('/authors/paged', {
    params: {
      pageNumber,
      pageSize,
      search
    }
  });
}